import React, { Component } from 'react'
import { Icon } from 'antd';
import { connect } from 'react-redux';
import moment from 'moment';
import { get_expcertificate } from './../actions/print.action'

import './../style.css';
import { times } from 'underscore';

class ExpCertificate extends Component {

    constructor( props ){
        super( props );

        this.state = {
            data: []
        }

    }

    componentWillMount(){
        let user_id = this.props.match.params.id;
        this.props.get_expcertificate( user_id );
    }

    componentWillReceiveProps( nextProps ){

        if( nextProps.print.length !== 0 ){
            if( nextProps.print.STATUS.CODE === '200' && 
                nextProps.print.STATUS.MESSAGE === "Successfully Listed Exp Certificate" ) {
                
                this.setState({
                    data : nextProps.print.OUTPUT.DATA[0]
                }); 

                setTimeout(() => {
                    window.print();
                },500)

            }
            
        }
        

    }

    handleHonorific( status, gender ){

        if( gender === 'male' ){
            if( status === 'married' || status === 'single' ){
                return 'Mr.';
            }
        }

        if( gender === 'female' ){
            if( status === 'married' ){
                return 'Mrs.';
            }
            if( status === 'single' ){
                return 'Miss.';
            }

        }


    }   

    handleDate_of_joining( date ){
        return moment( date ).format('Do of MMMM YYYY');
    }

    handleDate_of_exit( date ){
        return moment( date ).format('Do of MMMM YYYY');
    }

    handleDate_formate( date ){
        return moment( date ).format('Do of MMMM YYYY');
    }

    render() {
        return (
            <div className="print_wrapper letter">
                
                <table width="100%">

                    <thead>
                        <tr>
                            <th colSpan="2">
                                <span className="print_logo"></span>
                                <span className="jgroup_logo"></span>
                            </th>
                        </tr>
                    </thead>

                    <tbody>

                        <tr>
                            <td valign="top">

                                <table width="100%">
                                    <tbody>
                                        <tr>
                                            <td width="100%" style={{ height: '60px' }}>&nbsp;</td>
                                        </tr>
                                    </tbody>
                                </table>

                                <table width="100%">
                                    <tbody>
                                        <tr>
                                            <td style={{textAlign: 'right'}}>{ this.handleDate_formate( Date() ) }</td>
                                        </tr>
                                    </tbody>
                                </table>

                                <table width="100%">
                                    <tbody>
                                        <tr>
                                            <td width="100%" style={{ height: '30px' }}>&nbsp;</td>
                                        </tr>
                                    </tbody>
                                </table>

                                <table width="100%">
                                    <tbody>
                                        <tr>
                                            <td width="100%">
                                                <h2 style={{ textAlign: 'center', textDecoration: 'underline' }}>EXPERIENCE CERTIFICATE</h2>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>

                                <table width="100%">
                                    <tbody>
                                        <tr>
                                            <td width="100%" style={{ height: '60px' }}>&nbsp;</td>
                                        </tr>
                                    </tbody>
                                </table>
                                
                                <table width="100%">
                                    <tbody>
                                        <tr>
                                            <td width="100%">TO WHOM IT MAY CONCERN</td>
                                        </tr>
                                    </tbody>
                                </table>

                                <table width="100%">
                                    <tbody>
                                        <tr>
                                            <td width="100%" style={{ height: '30px' }}>&nbsp;</td>
                                        </tr>
                                    </tbody>
                                </table>

                                <table width="100%">
                                    <tbody>
                                        <tr>
                                            <td width="100%">
We are pleased to write this letter to inform you that <b>{ this.handleHonorific( this.state.data.marital_status, this.state.data.gender) } { this.state.data.full_name }</b>, 
holder of {this.state.data.country} Passport #{ this.state.data.passport_number } had been working for us, { this.state.data.company_name }, 
in { (this.state.data.gender === 'male') ? 'his': 'her' } capacity as a { this.state.data.designation_name } in the { this.state.data.department_name } Department from&nbsp;
{ this.handleDate_of_joining( this.state.data.date_of_joining )  } 
&nbsp;to { this.handleDate_of_exit( this.state.data.date_of_exit ) }.
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>

                                <table width="100%">
                                    <tbody>
                                        <tr>
                                            <td width="100%" style={{ height: '10px' }}>&nbsp;</td>
                                        </tr>
                                    </tbody>
                                </table>

                                <table width="100%">
                                    <tbody>
                                        <tr>
                                            <td width="100%">
                                            In this period, { (this.state.data.gender === 'male') ? 'he': 'she' } has shown full dedication and hard work towards { (this.state.data.gender === 'male') ? 'his': 'her' } concerned jobs which 
                                            has helped in improving the management of the company. Overall, { (this.state.data.gender === 'male') ? 'he': 'she' } has demonstrated excellent 
                                            behaviour during { (this.state.data.gender === 'male') ? 'his': 'her' } service with us and has contributed much to our organizational goals and 
                                            targets.
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>

                                <table width="100%">
                                    <tbody>
                                        <tr>
                                            <td width="100%" style={{ height: '10px' }}>&nbsp;</td>
                                        </tr>
                                    </tbody>
                                </table>

                                <table width="100%">
                                    <tbody>
                                        <tr>
                                            <td width="100%">
                                            { (this.state.data.gender === 'male') ? 'His': 'Her' } decision to leave our organization was { (this.state.data.gender === 'male') ? 'his': 'her' } sole decision, however we still hope { (this.state.data.gender === 'male') ? 'he': 'she' } will succeed in any path of career in the great future ahead.
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>

                                <table width="100%">
                                    <tbody>
                                        <tr>
                                            <td width="100%" style={{ height: '100px' }}>&nbsp;</td>
                                        </tr>
                                    </tbody>
                                </table>

                                <table width="100%">
                                    <tbody>
                                        <tr>
                                            <td width="100%">Yours sincerely,</td>
                                        </tr>
                                    </tbody>
                                </table>
                                <table width="100%">
                                    <tbody>
                                        <tr>
                                            <td width="100%" style={{ height: '20px' }}>&nbsp;</td>
                                        </tr>
                                    </tbody>
                                </table>
                                <table width="100%">
                                    <tbody>
                                        <tr>
                                            <td width="100%">{ this.state.data.reporting_manager_name }</td>
                                        </tr>
                                        <tr>
                                            <td width="100%"><em>{ this.state.data.reporting_manager_designation }</em></td>
                                        </tr>
                                    </tbody>
                                </table>

                            </td>
                        </tr>

                    </tbody>

                    <tfoot>
                        <tr>
                            <td width="100%" valign="top" colSpan={0}>

                                <table width="100%" className="fixed_footer">
                                    <tbody>
                                        <tr>
                                            <td valign="top" width="33.33%" style={{ color: '#999' }}>
                                                <span><b>{ this.state.data.company_name }</b></span>
                                                <span>{ this.state.data.website }</span>
                                            </td>
                                            <td valign="top" width="33.33%" style={{ color: '#999' }}>
                                                <span style={{width: '80%'}}>
                                                <i className="footer_icon maps_flags" />    
                                                { this.state.data.company_address }</span>
                                            </td>
                                            <td valign="top" width="33.33%" style={{ color: '#1185db' }}>
                                                <span><i className="footer_icon phone_call" />{ this.state.data.phone1 }</span>
                                                <span><i className="footer_icon email" />{ this.state.data.email }</span>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>

                            </td>
                        </tr>
                    </tfoot>

                </table>


            </div>
        )
    }
}

function mapStatetoProps( state ){
    return {
        print: state.print
    }
}

export default connect( mapStatetoProps, { get_expcertificate } )( ExpCertificate );



// WEBPACK FOOTER //
// ./src/pages/prints/expcertificate/index.js